import { useDispatch, useSelector } from 'react-redux';
import React, { ReactNode, useCallback, useMemo } from 'react';
import { INotification, ModalSystemContent, NotificationType } from '../types/types';
import {
    notificationActions,
    notificationSelector,
} from '../../../store/slices/notificationSlice/notificationSlice';
import { EntityId } from '@reduxjs/toolkit';

const validateTypes: string[] = [
    'estimate_archived',
    'estimate_unarchived',
    'employee_added_to_project',
    'user_added_to_estimate',
    'project_archived',
    'project_unarchived',
    'estimate_sent_to_customer',
    'payment_request_created',
    'payment_request_paid',
    'supply_request_created',
    'supply_request_status_changed',
    'receipt_added',
    'estimate_message_added',
    'position_refuse',
    'estimate_step_completed',
    'project_files_added',
    'project_step-by-step-photo_added',
    'payment_request_agreed',
    'payment_request_cancelled',
    'payment_request_removed',
    'task_given',
    'task_completed',
    'task_in_progress',
    'task_returned',
    'task_removed',
    'payment',
];

export const useNotificationItem = (
    id: EntityId,
    onOpenModalSystem: (data: ModalSystemContent) => void,
    onClose: () => void
) => {
    const dispatch = useDispatch();

    const currentNotification = useSelector((state) => notificationSelector.selectById(state, id));

    const onClickNotificationItem = useCallback(() => {
        if (currentNotification.type === NotificationType.SYSTEM) {
            onOpenModalSystem({
                content: currentNotification.context.content,
                header: currentNotification.context.title,
                date: currentNotification.context.created_at,
            });
            onClose();
            return;
        }
        if (validateTypes.includes(currentNotification.type)) {
            window.location.href = currentNotification.context.redirect_url;
            onClose();
            return;
        }
    }, []);

    const onViewNotification = useCallback(
        async (id: number) => {
            if (currentNotification.is_viewed) return;

            dispatch(
                notificationActions.changeNotificationMany([
                    {
                        id,
                        changes: {
                            is_viewed: true,
                        },
                    },
                ])
            );
            //@ts-ignore
            const url = routable.getRoute('notificationsSetIsViewed');

            await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                body: JSON.stringify([id]),
            });
        },
        [currentNotification]
    );

    return { currentNotification, onClickNotificationItem, onViewNotification };
};
